import useChartOptions from '@/components/Chart/hooks/options/useChartOptions';
import useForwardCurveOptions from '@/components/Chart/hooks/options/useForwardCurveOptions';
import useForwardCurveChartSeries from '@/components/Chart/hooks/useForwardCurveChartSeries';
import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

import AuthenticatedChart from './AuthenticatedChart';

const AuthenticatedFwdCurveChart = ({
  templateChartSeries
}: {
  templateChartSeries: TemplateChartSeries[];
}) => {
  const { loading, error, chartSeries } = useForwardCurveChartSeries(templateChartSeries);
  const { createOptions } = useForwardCurveOptions(14);
  const { options: chartOptions } = useChartOptions(chartSeries, createOptions);
  return (
    <AuthenticatedChart
      chartOptions={chartOptions}
      chartSeries={chartSeries}
      chartType='forwardSimple'
      error={error}
      loading={loading}
    />
  );
};

export default AuthenticatedFwdCurveChart;
